import styles from './styles.module.scss';

const DeviceExpired = () => {
  return <div className={styles.deviceExpired}>expired</div>;
};

export default DeviceExpired;
